import type { TranslationKey } from "../locales";
import { snakeCase } from "../strings";
import type { Absence } from "../types";

export function getAbsenceTypeTranslationKey(type: Absence["type"]): TranslationKey {
	switch (snakeCase(type)) {
		case "paid_vacation":
			return "personio.absence_categories.paid_vacation";
		case "unpaid_vacation":
			return "personio.absence_categories.unpaid_vacation";
		case "sick_leave":
			return "personio.absence_categories.sick_leave";
		case "parental_leave":
			return "personio.absence_categories.parental_leave";
		case "special_leave":
			return "personio.absence_categories.special_leave";
		case "offsite_work":
			return "personio.absence_categories.offsite_work";
		case "other":
			return "personio.absence_categories.other";
		case "azk_freizeitausgleich":
			return "personio.absence_categories.azk_freizeitausgleich";
		default:
			return "personio.absence_categories.other";
	}
}
